// Components==============
import Tippy from 'components/UI/Tooltip/Tippy';
import TooltipContextWrapper from 'components/UI/Tooltip/TooltipContextWrapper';
import { AnimatePresence } from 'framer-motion';
import React, { createContext, useContext, useState } from 'react';
import { GlobalUploadImageModalContext } from 'utilities/GlobalContext/GlobalUploadImageModal';
import Alert from './Alert/Alert';
import Confirm from './Confirm/Confirm';
import './Layout.module.scss';
import RootModal from './RootModal/RootModal';
import SideNav from './SideNav/SideNav';
import TopNav from './TopNav/TopNav';
import UploadImageModal from './UploadImageModal/UploadImageModal';
// =========================

type LayoutContextType = {
  hamburgerIsOpen: boolean;
  setHamburgerIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const LayoutContext = createContext({} as LayoutContextType);

export default function Layout({
  children,
  filter,
  grey,
}: {
  children: React.ReactNode;
  filter?: React.ReactNode;
  grey?: boolean;
}) {
  const [hamburgerIsOpen, setHamburgerIsOpen] = useState(false);

  const { uploadImageModalIsOpen, setUploadImageModalIsOpen } = useContext(
    GlobalUploadImageModalContext
  );

  return (
    <LayoutContext.Provider value={{ hamburgerIsOpen, setHamburgerIsOpen }}>
      <TooltipContextWrapper>
        <div styleName={`layout ${filter ? 'with-filter' : ''}`}>
          <div styleName="side">
            <SideNav />
          </div>
          {filter && <div styleName="filter">{filter}</div>}
          <div styleName="top">
            <TopNav />
          </div>
          <div
            styleName={`content ${filter ? 'has-filter' : ''}`}
            id="scroll-container"
            style={{ background: grey ? '#f2f2f2' : '' }}
          >
            {children}
          </div>
          <Alert />
          <Confirm />
          <Tippy />
          <RootModal />
          <AnimatePresence>
            {uploadImageModalIsOpen && (
              <UploadImageModal setModalIsOpen={setUploadImageModalIsOpen} />
            )}
          </AnimatePresence>
        </div>
      </TooltipContextWrapper>
    </LayoutContext.Provider>
  );
}
